<template>
    <div>
        <div class="step-content campaign-info">
            <v-form v-model="formValid" ref="form">
                <v-container fluid class="pl-0 pr-0">
                    <div class="campaign-form">
                        <div style="width: 350px;">
                            <div class="label">{{ $f.tc('type') }}</div>
                            <v-select
                                v-model="model.direction"
                                :items="directionData"
                                :disabled="!!(campaign)"
                                :rules="formRules.required"
                                class="input-custom"
                            ></v-select>
                        </div>
                        <div style="width: 350px; margin-top: 12px">
                            <div class="label">{{ $f.tc('title') }}</div>
                            <v-text-field
                                v-model="model.title"
                                :rules="formRules.required"
                                class="input-custom"
                            ></v-text-field>
                        </div>
                    </div>
                </v-container>
            </v-form>
        </div>
        <div class="step-actions">
            <div v-if="canGoBack" @click="goBack" class="btn-custom btn-back" dark>
                {{ backTitle || $f.tc('back') }}
            </div>
            <div @click="submit" class="btn-custom" style="margin-left: 8px">
                {{ nextTitle || $f.tc('next') }}
            </div>
            <div v-if="isEdit" @click="submit($event, true)" class="btn-custom" style="margin-left: 8px">
                {{ $f.tc('save') }}
            </div>
        </div>
    </div>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import { mapState } from 'vuex'

export default {
    name: 'NewCampaignStep1',
    mixins: [
        FormMixin,
        RoleMixin
    ],
    props: {
        next: Function,
        nextTitle: String,
        back: Function,
        canGoBack: Boolean,
        backTitle: String
    },
    data () {
        return {
            formValid: false,
            directionData: ['INBOUND', 'OUTBOUND'],
            model: {
                direction: '',
                title: '',
                bot_info: null
            }
        }
    },
    mounted () {
        if (!this.isAdmin()) {
            // remove 'INBOUND'
            this.directionData.shift()
            this.model.direction = 'OUTBOUND'
        }
        if (this.campaign) {
            this.model = Object.assign({}, this.campaign)
        }
        this.$nextTick().then(() => {
            this.$refs.form.resetValidation()
        })
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign,
            isEdit: state => state.campaign.isEdit
        })
    },
    methods: {
        submit (event, done) {
            if (event) {
                event.preventDefault()
            }
            if (this.formValid) {
                this.$appService.dataLoading(true)
                this.$store.dispatch(this.$actionTypes.campaign.UPDATE_CAMPAIGN, {
                    campaign: this.campaign,
                    model: this.model
                }).then(() => {
                    if (typeof this.next === 'function') {
                        this.next(done)
                    }
                }).finally(() => {
                    this.$appService.dataLoading(false)
                })
            } else {
                this.$refs.form.validate()
            }
        },
        goBack () {
            if (typeof this.back === 'function') {
                this.back()
            }
        }
    },
    watch: {
        campaign (value) {
            this.model = Object.assign({}, value)
        }
    },
    destroyed () {
        this.model = {
            direction: '',
            title: ''
        }
    }
}
</script>
<style scoped lang="scss">
.campaign-info {
    display: block;
    margin: 0 auto;
    width: 100%;
    max-width: 1080px;
}

.campaign-form {
    display: flex;
    flex-direction: column;
    align-items: center;

    .label {
        font-family: "open sans semi";
        margin-bottom: 6px;
        font-size: 13px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input__control {
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 17px;
        top: 10px;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}

@media screen and (min-width: 600px) {
    .campaign-info {
        padding: 20px 0 20px;
    }
}
</style>
